import { Sponsor } from '../types';

export const sponsors: Sponsor[] = [
  {
    name: "fabworks",
    description: "High quality laser cutting for sheet metal and tube. Use code 'LEVEL5' for 5% off your order.",
    logo: "/fabworks.png",
    url: "https://fabworks.com"
  },
  {
    name: "Repeat Robotics",
    description: "Robot components by champions, for champions.",
    logo: "/repeat.png",
    url: "https://repeat-robotics.com"
  },
  {
    name: "REV Robotics",
    description: "Educational and competition robot components and kits created by veterans of the sport.",
    logo: "/rev.svg",
    url: "https://www.revrobotics.com/"
  }
]; 